import { Form, Select } from "antd";
import React from "react";
import { useIntl } from "react-intl";
import { isEmpty } from "../../Lib/Utils/validationUtil";
import "./style.css"; // External CSS for styling
import {
  ICustomDropDownOption,
  ICustomDropDownProp,
} from "../../Orchestrator/Types/Interface/IServiceRequest";
import stopManager from "../../Lib/Utils/StopManager";
const { Option } = Select;

const CustomDropDown: React.FC<ICustomDropDownProp> = ({
  placeHolderTranslationKey,
  labelTranslationKey,
  validationRules = [],
  Options,
  value,
  disabled = false,
  onChange,
  labelMode = "translationKey",
  className,
  suffixIcon,
}) => {
  const intl = useIntl();
  return (
    <Form.Item
      className="custom-dropdown-main"
      label={
        labelTranslationKey
          ? intl.formatMessage({ id: labelTranslationKey })
          : ""
      }
      rules={validationRules.length > 0 ? validationRules : []}
    >
      <Select
        disabled={disabled}
        onChange={onChange}
        allowClear
        className={className}
        suffixIcon={suffixIcon}
        value={!isEmpty(value) ? value : null} // Required
        placeholder={
          placeHolderTranslationKey ? (
            <span className="ant-select-selection-item place-holder">
              {/* {intl.formatMessage({ id: placeHolderTranslationKey })} */}
              {placeHolderTranslationKey}
            </span>
          ) : (
            <></>
          )
        }
      >
        {Options.map((option: ICustomDropDownOption, index: number) => {
          const rendered =
            option.label !== undefined
              ? option.label
              : labelMode === "rawLabel"
                ? option.labelTranslationKey
                : labelMode === "stopName"
                  ? stopManager.getStopNameById(option.labelTranslationKey)
                  : intl.formatMessage({ id: option.labelTranslationKey });
          return (
            <Option key={index} value={option.value}>
              {rendered}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default CustomDropDown;
